<template>
  <div
    id="ooo_banner"
    class="has-background-primary-light has-text-primary flex items-center justify-center rounded-full p-2 font-bold"
  >
    <p>{{ client.attributes.ooo_note || $t('client.labels.outOfOffice') }}</p>
  </div>
</template>

<script setup>
import 'vue';

defineProps({
  client: { type: Object, required: true },
  profile: { type: Object, required: true },
});
</script>
